<div class="row page-head ng-scope">
  <div class="col-xs-12 col-sm-offset-3 col-sm-5" style="margin-left: 25%">
    <table>
      <tbody>
        <tr>
          <td rowspan="2" width="83px" height="83px">
            <img height="60px" src="assets/img/NAVY.png" />
          </td>
          <td>
            <span id="header-title" class="profileName"
              >{{ shipData.shipName }} ({{ shipData.shipHull }})</span
            >
          </td>
        </tr>
        <tr>
          <td>
            <span id="header-text1" class="profileGrade">{{
              shipData.shipLocation
            }}</span>
            <span id="header-text2" class="profileGrade">{{
              commissionedState
            }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <app-ship-header-search
    [shipSearchResultArray]="shipResultArray"
    (newShipSelected)="newShipSelected($event)"
  >
  </app-ship-header-search>
</div>
